import React, { Component } from 'react';
import { Button } from 'antd';
import { UserOutlined, RightOutlined, FileProtectOutlined } from '@ant-design/icons';

const STATUS_DATA = [
  {
    id: 1,
    name: 'Đang chờ điều xe',
    color: '#fbe350'
  },
  {
    id: 2,
    name: 'Đã điều xe',
    color: '#e68927'
  },
  {
    id: 3,
    name: 'Đang diễn ra',
    color: '#45acf9'
  },
  {
    id: 4,
    name: 'Đã hoàn thành',
    color: '#139123'
  },
  {
    id: 5,
    name: 'Đã huỷ',
    color: '#d11338'
  },
  {
    id: 6,
    name: 'Đang cho mượn xe',
    color: '#b330dc'
  },
  {
    id: 7,
    name: 'Đang cho mượn tài',
    color: '#32dc8e'
  },
  {
    id: 8,
    name: 'Đang cho mượn xe và tài',
    color: '#E60EBB'
  }
]

export class ContractTitle extends Component {

  renderStatus = () => {
    const { contract_status } = this.props;
    const findIndex = STATUS_DATA.findIndex(value => {
      return value.id === contract_status;
    });
    if (findIndex !== -1) {
      return <div className="status-item">
        <span style={{ background: STATUS_DATA[findIndex].color }} className="circle" />
        {STATUS_DATA[findIndex].name}
      </div>
    }
  }

  render() {
    const { editPage, isEdit, isEditHistory, close, goToDetail, include_appendix, showAddCustomerModal } = this.props;
    return (
      <div className="add-new-customer-container contract-title">
        <div className="add-new-contract-title">
          <span onClick={close}>Danh sách hợp đồng{' '}</span>
          <RightOutlined />
          <span onClick={goToDetail}>{' '}{editPage && !isEdit ? 'Chi tiết hợp đồng' : (
            editPage && isEdit ? 'Chỉnh sửa hợp đồng' : 'Thêm hợp đồng mới'
          )}{' '}</span>
          {isEditHistory && <>
            <RightOutlined />
            <span>
              {' '}Lịch sử chỉnh sửa hợp đồng</span></>}
        </div>
        {!isEditHistory && (
          editPage ?
            <div className="status-container">
              {include_appendix && <div className="contract-annex">
                <FileProtectOutlined style={{ fontSize: 15, marginRight: 5 }} />
              Có phụ lục hợp đồng
            </div>}
              {this.renderStatus()}
            </div> :
            <Button onClick={showAddCustomerModal} className="add-new-customer" icon={< UserOutlined />}>
              Thêm KH mới
          </Button>
        )}
      </div>
    )
  }
}
